var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-fade"}},[(_vm.showNotification)?_c('div',{class:['internet-notification', _vm.notificationClass]},[_c('div',{staticClass:"notification-content"},[_c('i',{class:_vm.notificationIcon}),_c('span',[_vm._v(_vm._s(_vm.notificationMessage))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }